import RequirePermissions from '@/components/auth/requirePermissions';
import { FlagGuard } from '@/components/FlagGuard/FlagGuard';

import { OrganizationPricingTabType, UserPermissions } from 'types';

import { DomesticContent } from './DomesticContent';
import { EnergyCommunity } from './EnergyCommunity';
import { EquipmentSettings } from './EquipmentSettings';
import { Holdbacks } from './Holdbacks';
import { Mappings } from './Mappings';
import { PpwModifiers } from './PpwModifiers';
import { PropertyType } from './PropertyType';
import { SiteSurvey } from './SiteSurvey';

export const SectionOption = {
  [OrganizationPricingTabType.mappings]: <Mappings />,
  [OrganizationPricingTabType.energyCommunity]: <EnergyCommunity />,
  [OrganizationPricingTabType.ppwModifiers]: <PpwModifiers />,
  [OrganizationPricingTabType.holdbacks]: <Holdbacks />,
  [OrganizationPricingTabType.domesticContent]: <DomesticContent />,
  [OrganizationPricingTabType.equipmentSettings]: (
    <FlagGuard required={['enableSafeHarborPricingSettings']} redirectTo="/">
      <RequirePermissions permissions={[UserPermissions.lightReachSafeHarborEquipmentPricing]}>
        <EquipmentSettings />
      </RequirePermissions>
    </FlagGuard>
  ),
  [OrganizationPricingTabType.siteSurvey]: (
    <FlagGuard required={['enableSiteSurveyPricingOrgSettings']} redirectTo="/">
      <SiteSurvey />
    </FlagGuard>
  ),
  [OrganizationPricingTabType.propertyType]: (
    <FlagGuard required={['enablePropertyTypeOrgSettings']} redirectTo="/">
      <PropertyType />
    </FlagGuard>
  ),
};
